<template>
  <div class="piecesMobile h-screen">
    <div class="title">
      {{ data?.name }}
    </div>
    <div
      class="video-info mt-[20px] h-[calc(100%-280px)] flex-y-center justify-center"
      :class="!isHorizontal ? 'items-baseline' : ''"
    >
      <div
        class="bg-black rounded-[12px] overflow-hidden w-full"
        :class="
          !isHorizontal
            ? 'mx-[16px] wrapper '
            : 'mx-[30px] h-full aspect-video '
        "
      >
        <VideoPlayers
          :url="data?.video_url"
          :poster="data?.cover_url"
          :muted="true"
          :autoplay="true"
          :controls="true"
          :loop="false"
          :noIcon="true"
        />
      </div>
      <div class="footer">
        <x-button
          v-if="isChinese()"
          theme="blank-primary"
          @click="() => showContact()"
        >
          {{ $t('lian-xi-wo-men') }}
        </x-button>
        <x-button theme="blank-default" @click="handleCopy">
          <iconpark-icon name="share-link" class="icon-link mr-[5px]" />
          {{ $t('fu-zhi-lian-jie-fen-xiang-gai-nei-rong') }}
        </x-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import VideoPlayers from '~/features/publicize/videoPlayer.vue'
import XButton from '~/components-mobile/atom/x-button.vue'
import message from '~/components-mobile/atom/x-alert/index.ts'
import { showContact } from '~/hooks/useModal/modals/contact'

const { $t } = useNuxtApp()

const props = defineProps(['data'])

const isHorizontal = computed(
  () => props.data?.project_resolution === '1080x1920'
)

const handleCopy = () => {
  try {
    copyToClipboard(location.href)
    message.success($t('fu-zhi-cheng-gong'))
  } catch (error) {
    console.error(error)

    message.error($t('wen-ben-fu-zhi-shi-bai'))
  }
}
</script>

<style lang="scss">
.piecesMobile {
  .more {
    background: #d4d9fc;
    position: fixed;
    top: 0;
    padding: 4px;
    width: 100%;
    text-align: center;
    color: #2e1d66;
    line-height: 24px;
    z-index: 1111111;
  }
  .wrapper {
    height: m-rem(194);
  }
  .title {
    @apply px-[16px] truncate;
    font-weight: 500;
    font-size: 18px;
    color: var(--text-1);
    line-height: 24px;
    padding-top: 20px;
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: m-rem(20) m-rem(16);
  }
  .container-btn {
    background-size: 110px;
  }
}
</style>
